/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';

import {
  ILoadingContentPluginMethods,
  LoadingContentPlugin,
  IErrorContentPluginMethods,
  ErrorContentPlugin,
  ISignInUserMethods,
  SignInUserPlugin,
  IStaticPageContentMethods,
  StaticPageContentPlugin,
} from './plugins';

export type TAgent = IStaticPageContentMethods &
  ILoadingContentPluginMethods &
  IErrorContentPluginMethods &
  ISignInUserMethods;

const getPlugins = () => {
  return [
    new ErrorContentPlugin(),
    new LoadingContentPlugin(),
    new SignInUserPlugin(),
    new StaticPageContentPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
